












































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { agencyStore, projectStore } from '@/store/store';
import { UnitSystem } from '@/interfaces/units';
import AgencyCostActivityEditor from '@/modules/agencyCost/views/components/AgencyCostActivityEditor.vue';
import AgencyCostPlot from '@/modules/agencyCost/views/components/AgencyCostPlot.vue';
import { IAgencyCostLineItemImperial, LineItemTypes } from '@/modules/agencyCost/interfaces/agencyCost';
import { defaultLineItems } from '@/modules/agencyCost/lib/unitCostsAndMeasures';
import {
  ImperialUnits,
  MetricUnits,
  roundAfterUnitConversion,
  UnitMapImperialToMetric,
} from '@/lib/unitConversion/unitConversionFactors';
import AgencyCostEditLineItemModalContent
  from '@/modules/agencyCost/views/components/AgencyCostEditLineItemModalContent.vue';
import AgencyCostScenarioContainer from '@/modules/agencyCost/views/components/AgencyCostScenarioContainer.vue';
import ProjectBreadcrumb from '@/views/components/projects/ProjectBreadcrumb.vue';
import { convertImperialToMetric } from '@/modules/lcca/lib/unitConversion/lccaScenario';
import { IProjectMetadata } from '@/interfaces/report';

Component.registerHooks(['validations']);

@Component({
  components: {
    ProjectBreadcrumb,
    AgencyCostScenarioContainer,
    AgencyCostEditLineItemModalContent,
    AgencyCostActivityEditor,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
    AgencyCostPlot,
  },
})
export default class AgencyCostDefaultLineItems extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;


  currentProject: IProjectMetadata | null = null;

  // availableDefaultsImperial: IAgencyCostLineItemImperial[] = [];

  availableHardCosts: IAgencyCostLineItemImperial[] = [];

  availableOperations: IAgencyCostLineItemImperial[] = [];

  // get availableDefaultsMetric() {
  //   return this.availableDefaultsImperial.map((item) => agencyLineItemImperialToMetric(item));
  // }


  fieldsImperial = [
    // 'id',
    'custom',
    'name',
    'mainline',
    'type',
    'unitCost',
    'units',
    'actions',
  ];

  itemToEditImperial: IAgencyCostLineItemImperial | null = null;

  unitSystems = UnitSystem;

  unitMapImperialToMetric = UnitMapImperialToMetric;

  convertImperialToMetric = convertImperialToMetric;

  roundAfterUnitConversion = roundAfterUnitConversion;

  setItemToEdit(item: IAgencyCostLineItemImperial) {
    this.itemToEditImperial = item;
  }

  get scenario() {
    return agencyStore.currentScenario;
  }

  get scenarioImperial() {
    return agencyStore.currentImperial;
  }

  get isImperial() {
    return agencyStore.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    console.log('sync');
    // this.$emit('sync');
    this.loadLineItems();
  }

  save() {
    this.sync();
  }

  validations() {
    return null;
  }

  loadLineItems() {
    this.availableHardCosts = [];
    this.availableOperations = [];
    const basicHardCosts = defaultLineItems.filter((item) => item.type === LineItemTypes.HARDCOST);
    const basicOperations = defaultLineItems.filter((item) => item.type === LineItemTypes.OPERATION);

    agencyStore.loadLineItemDefaults().then((items: IAgencyCostLineItemImperial[]) => {
      const hardCosts = items.filter((item) => item.type === LineItemTypes.HARDCOST);
      this.availableHardCosts.push(...hardCosts);
      this.availableHardCosts.push(...basicHardCosts);

      const operations = items.filter((item) => item.type === LineItemTypes.OPERATION);
      this.availableOperations.push(...operations);
      this.availableOperations.push(...basicOperations);
    });
  }

  deleteItem(item: IAgencyCostLineItemImperial) {
    console.log('deleting', item.id);
    if (item) {
      agencyStore.deleteDefaultLineItem(item).then((result) => {
        this.sync();
      });
    }
  }

  finishSave() {
    this.$bvModal.hide('edit-default-modal');
  }

  mounted() {
    projectStore.getProjectMetadata(projectStore.currentProjectId).then((result) => this.currentProject = result);

    this.loadLineItems();

    // Reload list after changes made using modal
    this.$root.$on('bv::modal::hide', (bEvent: any, modalId: string) => {
      if (modalId === 'edit-default-modal') {
        this.loadLineItems();
      }
    });
  }

  get unitOptions() {
    if (this.isImperial) {
      return Object.values(ImperialUnits).map((U) => ({ value: U, text: U }));
    }
    return Object.values(MetricUnits).map((U) => ({ value: U, text: U }));
  }
}

